import { render, staticRenderFns } from "./CategorizedTaxInvoice.vue?vue&type=template&id=4db1ed93&"
import script from "./CategorizedTaxInvoice.vue?vue&type=script&lang=js&"
export * from "./CategorizedTaxInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports